module.exports = __webpack_public_path__ + "media/images/menu/mensa-7e6d74a1c185a4e5092f1d966a2e3602.jpg";